import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Stack
} from "@mui/material";
import MobileContainer from "../global/components/MobileContainer";
import { MAIN_COLOR_RED } from "../assets/styles";
import { useNavigate } from "react-router-dom";
import Navbar from "../global/components/Navbar";

const ShoppingGoalPage: React.FC = () => {
    const [selectedGoal, setSelectedGoal] = useState<string | null>(null);
    const navigate = useNavigate();

    const goals = [
        { value: "minimize", label: "Minimize shopping time" },
        { value: "explore", label: "Find new products and promotions" },
    ];

    const handleSelect = (value: string) => {
        setSelectedGoal(value);
    };

    return (
        <Box sx={{ minHeight: "100vh", backgroundColor: "#fff", display: "flex", flexDirection: "column" }}>
            {/* Top Navbar */}
            <Navbar />

            <MobileContainer centerContent={false}>
                <Box textAlign="center" width="100%">
                    <Typography variant="subtitle1" fontWeight="bold" mb={0.5}>
                        What is your shopping goal today?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={4}>
                        Select one option
                    </Typography>

                    <Stack spacing={2} alignItems="center">
                        {goals.map((goal) => (
                            <Button
                                key={goal.value}
                                variant="outlined"
                                onClick={() => handleSelect(goal.value)}
                                sx={{
                                    borderColor: selectedGoal === goal.value ? MAIN_COLOR_RED : "#ffe5e5",
                                    color: selectedGoal === goal.value ? MAIN_COLOR_RED : "#d32f2f",
                                    backgroundColor: selectedGoal === goal.value ? "#fff" : "#fffafa",
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    width: "100%",
                                    maxWidth: 300,
                                    py: 1.5,
                                    borderWidth: 2,
                                    "&:hover": {
                                        backgroundColor: "#fff0f0",
                                    },
                                }}
                            >
                                {goal.label}
                            </Button>
                        ))}
                    </Stack>

                    {/* Footer Buttons */}
                    <Box mt={6} display="flex" justifyContent="space-between" maxWidth={300} mx="auto">
                        <Button
                            variant="outlined"
                            color="error"
                            fullWidth
                            sx={{ mr: 1 }}
                            onClick={() => navigate(-1)}
                        >
                            Previous
                        </Button>

                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                ml: 1,
                                backgroundColor: MAIN_COLOR_RED,
                                "&:disabled": {
                                    backgroundColor: "#f5c6cb",
                                    color: "#fff",
                                },
                            }}
                            disabled={!selectedGoal}
                            onClick={() => navigate("/generating-route")}
                        >
                            Next
                        </Button>
                    </Box>
                </Box>
            </MobileContainer>
        </Box>
    );
};

export default ShoppingGoalPage;
